import { SxProps, Theme } from '@mui/material';

export const stylesPrivacyStatementPaper: SxProps<Theme> = { p: 2 };
